import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const languages = [{
  code: 'nl',
  name: 'Nederlands',
  flag: '🇳🇱'
}, {
  code: 'en',
  name: 'English',
  flag: '🇬🇧'
}, {
  code: 'fr',
  name: 'Français',
  flag: '🇫🇷'
}, {
  code: 'de',
  name: 'Deutsch',
  flag: '🇩🇪'
}];
interface LanguageSwitcherProps {
  currentLang?: string;
  onChangeLanguage?: (lang: string) => void;
}
const LanguageSwitcher = ({
  currentLang = 'nl',
  onChangeLanguage = () => {}
}: LanguageSwitcherProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const currentLanguage = languages.find(lang => lang.code === currentLang) || languages[0];
  const handleSelectLanguage = (code: string) => {
    onChangeLanguage(code);
    setIsOpen(false);
  };
  return <div className="relative" data-id="element-48">
      <button onClick={() => setIsOpen(!isOpen)} className="flex items-center text-sm bg-white/10 hover:bg-white/20 rounded-lg py-1 px-2 transition-colors" aria-label="Taal selecteren" aria-expanded={isOpen} data-id="element-49">
        <span className="mr-1" data-id="element-50">{currentLanguage.flag}</span>
        <span className="mr-1" data-id="element-51">{currentLanguage.code.toUpperCase()}</span>
        <ChevronDownIcon size={16} className={isOpen ? 'transform rotate-180' : ''} data-id="element-52" />
      </button>
      {isOpen && <div className="absolute right-0 mt-1 bg-white rounded-lg shadow-lg overflow-hidden z-50 w-32 border border-gray-100" data-id="element-53">
          {languages.map(language => <button key={language.code} onClick={() => handleSelectLanguage(language.code)} className={`w-full text-left px-3 py-2 hover:bg-gray-100 flex items-center transition-colors ${language.code === currentLang ? 'bg-gray-100' : ''}`} data-id="element-54">
              <span className="mr-2" data-id="element-55">{language.flag}</span>
              <span data-id="element-56">{language.name}</span>
            </button>)}
        </div>}
    </div>;
};
export default LanguageSwitcher;